import { render } from "./App.vue?vue&type=template&id=50eac133&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=50eac133&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2120122782/src/remote-config-panel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50eac133"]])

export default __exports__